'use client';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import usePusherChannel from '../../hooks/use-pusher';
import { useEffect, useState } from 'react';
import { LoggedOffDialog } from './logged-of-dialog';
import { ResponsiveDialogProvider } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { fetchMe } from '@eliadmin/core/src/api/customers/customers-api';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const GlobalWebsockets = () => {
  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);
  const [loggedOff, setLoggedOff] = useState(false);

  const messageData = usePusherChannel(
    me?.customer.id || 0,
    '.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
  );

  useEffect(() => {
    if (messageData) {
      if (messageData.type === 'check-login-status') {
        fetchMe({
          locale,
          authToken: me?.authToken ?? '',
        }).catch(() => {
          setLoggedOff(true);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageData]);

  useEffect(() => {
    if (!loggedOff) return;
    const id = setTimeout(() => {
      window.location.reload();
    }, 5000);
    return () => clearTimeout(id);
  }, [loggedOff]);

  return <ResponsiveDialogProvider>{loggedOff && <LoggedOffDialog />}</ResponsiveDialogProvider>;
};
